// extracted by mini-css-extract-plugin
export default {"container":"sKPXib32hjbNEhKAWOjI","icon":"I_Hc2KX_VbwGz8UwQPlE","success-icon":"vo5E9PwPwl3mUPVJnA8T"};